import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";
import { Button, Col, DatePicker, Row, Select, Space } from "antd";
import { PlannerViewTableProps } from "./PlannerViewTable";

interface PlannerFiltersProps {
  filters: PlannerViewTableProps["filters"];
  setFilters: PlannerViewTableProps["setFilters"];
  getCustomWeek: (date: Dayjs) => number;
  setWeek: (date: Dayjs) => void;
  currentStart: Dayjs;
  handlePlannerOpen: (value: boolean) => void;
}

const { RangePicker } = DatePicker;

const PlannerFilters: FC<PlannerFiltersProps> = ({
  filters,
  setFilters,
  getCustomWeek,
  setWeek,
  currentStart,
  handlePlannerOpen,
}) => {
  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col>
        <Select
          mode="multiple"
          placeholder="PROCESS: ALL"
          style={{ width: 250 }}
          allowClear
          value={filters.process}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, process: value }))
          }
        >
          <Select.Option value="Extruder">Extruder</Select.Option>
          <Select.Option value="Rewinder #1">Rewinder #1</Select.Option>
          <Select.Option value="Rewinder #2">Rewinder #2</Select.Option>
        </Select>
      </Col>

      <Col>
        <Space>
          <RangePicker
            value={filters.dateRange}
            onChange={(dates) =>
              setFilters((prev) => ({
                ...prev,
                dateRange: dates ?? [null, null],
              }))
            }
            separator="—"
            format={(value) =>
              `${value.format("YYYY-MM-DD")} (W${getCustomWeek(value)})`
            }
            renderExtraFooter={() => (
              <Space>
                <Button size="small" onClick={() => setWeek(dayjs())}>
                  This week
                </Button>
                <Button
                  size="small"
                  onClick={() => setWeek(currentStart.subtract(1, "week"))}
                >
                  ← Prev
                </Button>
                <Button
                  size="small"
                  onClick={() => setWeek(currentStart.add(1, "week"))}
                >
                  Next →
                </Button>
              </Space>
            )}
          />
        </Space>
      </Col>

      <Col>
        <Select
          placeholder="STATUS: ALL"
          style={{ width: 200 }}
          allowClear
          value={filters.status}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, status: value }))
          }
        >
          <Select.Option value="PENDING">PENDING</Select.Option>
          <Select.Option value="FC">FC</Select.Option>
          <Select.Option value="ACTIVE">ACTIVE</Select.Option>
        </Select>
      </Col>
      <Col>
        <Button type="primary" style={{ backgroundColor: themeColor }}>
          Calculate
        </Button>
      </Col>
      <Col>
        <Button
          onClick={() => handlePlannerOpen(true)}
          type="primary"
          style={{ backgroundColor: themeColor }}
        >
          Open Schedule
        </Button>
      </Col>
    </Row>
  );
};

export { PlannerFilters };
